export const localStorageUserKey = "user_almorzadiario";
export const localStorageOrderKey = "order_almorzadiario";
